import { IsNumber } from 'class-validator';

export class GiftCardPhysicalCardProcessRequestDto {
  @IsNumber()
  giftCardPhysicalCardId: number;
  @IsNumber()
  giftCardId: number;

  constructor(giftCardPhysicalCardId: number, giftCardId: number) {
    this.giftCardPhysicalCardId = giftCardPhysicalCardId;
    this.giftCardId = giftCardId;
  }
}
